import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "flex-none font-sans font-bold break-normal text-gray-700 p-1" }
const _hoisted_3 = { class: "flex-none p-4 mt-2 rounded shadow bg-white" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "text-xs text-pink-600" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-2" }, "転送先URL", -1)
const _hoisted_8 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "text-xs text-pink-600" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-2" }, "表示期間", -1)
const _hoisted_12 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = { class: "text-xs text-pink-600" }
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = { class: "text-xs text-pink-600" }
const _hoisted_17 = { class: "flex-none p-4 mt-2 rounded shadow bg-white" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-2" }, "対象年齢", -1)
const _hoisted_19 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_20 = { class: "relative" }
const _hoisted_21 = { class: "text-xs text-pink-600" }
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = { class: "text-xs text-pink-600" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-2" }, "対象性別", -1)
const _hoisted_25 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = { class: "form-check-label text-sm inline-block text-gray-800 mr-2" }
const _hoisted_28 = { class: "form-check-label text-sm inline-block text-gray-800" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-2" }, "対象消費額", -1)
const _hoisted_30 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_31 = { class: "relative" }
const _hoisted_32 = { class: "form-check-label text-sm inline-block text-gray-800 mr-2" }
const _hoisted_33 = { class: "form-check-label text-sm inline-block text-gray-800 mr-2" }
const _hoisted_34 = { class: "form-check-label text-sm inline-block text-gray-800 mr-2" }
const _hoisted_35 = { class: "form-check-label text-sm inline-block text-gray-800 mr-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "block mt-2" }, "対象都道府県", -1)
const _hoisted_37 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_38 = { class: "relative" }
const _hoisted_39 = { class: "form-check-label text-sm inline-block text-gray-800 mr-2" }
const _hoisted_40 = ["data-pindex", "onUpdate:modelValue"]
const _hoisted_41 = { class: "flex-grow p-2 mt-2 rounded shadow bg-white" }
const _hoisted_42 = { class: "grid grid-cols-1 gap-3 my-4" }
const _hoisted_43 = { class: "relative" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label inline-block text-gray-800",
  for: "form_show_detail_page"
}, " 詳細ページを表示する ", -1)
const _hoisted_45 = { class: "text-xs text-pink-600" }
const _hoisted_46 = { class: "flex-none text-right col-span-full mt-4" }
const _hoisted_47 = ["onClick"]

import { FieldContext, useField, useForm } from "vee-validate";
import * as yup from "yup";
import { Storage } from "aws-amplify";
// import { uuid } from "vue-uuid";
// import moment from "moment";
import Editor from "@tinymce/tinymce-vue";

import { PREFECTURES } from "@/utils/prefectures";
import Advertisement from "@/models/Advertisement";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import moment from "moment";
import { uuid } from "vue-uuid";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvertisementEdit',
  setup(__props) {

// import { defineComponent, Ref } from "vue";
const PREFECTURE_NAMES = PREFECTURES;

const store = useStore();
const route = useRoute();
const router = useRouter();
// interface AdvertisementEditState {
//   // is_loading: boolean;

//   advertisement: Advertisement | null;

//   title_field: FieldContext<string>;
//   title: Ref<string>;
//   title_error: Ref<string>;

//   redirect_url_field: FieldContext<string>;
//   redirect_url: Ref<string>;
//   redirect_url_error: Ref<string>;

//   publish_from_field: FieldContext<string>;
//   publish_from: Ref<string>;
//   publish_from_error: Ref<string>;

//   publish_to_field: FieldContext<string>;
//   publish_to: Ref<string>;
//   publish_to_error: Ref<string>;

//   age_from_field: FieldContext<string>;
//   age_from: Ref<number | null>;
//   age_from_error: Ref<string>;

//   age_to_field: FieldContext<string>;
//   age_to: Ref<number | null>;
//   age_to_error: Ref<string>;

//   gender_male: boolean;
//   gender_female: boolean;

//   consumption_0: boolean;
//   consumption_30000: boolean;
//   consumption_50000: boolean;
//   consumption_100000: boolean;

//   prefectures: boolean[];
//   prefecture_names: string[];

//   show_detail_page: boolean;

//   body_field: FieldContext<string>;
//   body: Ref<string>;
//   body_error: Ref<string>;

//   mceCallback: (uri: string, option: any) => void;
// }

// export default defineComponent({
//   components: {
//     Editor,
//   },

//   data() {
const prefectures = ref<boolean[]>([]);

PREFECTURE_NAMES.forEach((p) => prefectures.value.push(false));

const advertisement = ref<Advertisement | null>(null);

const formSchema = yup.object({
  title: yup.string().required("必須項目です"),
  redirect_url: yup.string().url().required("必須項目です"),
  publish_from: yup.string(),
  publish_to: yup.string(),
  age_from: yup.number(),
  age_to: yup.number(),
  body: yup.string().required("必須項目です"),
});

useForm({ validationSchema: formSchema });

const title_field = useField<string>("title");
const title = title_field.value;
const title_error = title_field.errorMessage;

const redirect_url_field = useField<string>("redirect_url");
const redirect_url = redirect_url_field.value;
const redirect_url_error = redirect_url_field.errorMessage;

const publish_from_field = useField<string>("publish_from");
const publish_from = publish_from_field.value;
const publish_from_error = publish_from_field.errorMessage;

const publish_to_field = useField<string>("publish_to");
const publish_to = publish_to_field.value;
const publish_to_error = publish_to_field.errorMessage;

const age_from_field = useField<number | null>("age_from");
const age_from = age_from_field.value;
const age_from_error = age_from_field.errorMessage;

const age_to_field = useField<number | null>("age_to");
const age_to = age_to_field.value;
const age_to_error = age_to_field.errorMessage;

const body_field = useField<string>("body");
const body = body_field.value;
// const body_error = body_field.errorMessage;
const body_error = ref<string | null>();

//     return {
//       // is_loading: false,

//       advertisement: null,

//       title_field: title,
//       title: title.value,
//       title_error: title.errorMessage,

//       redirect_url_field: redirect_url,
//       redirect_url: redirect_url.value,
//       redirect_url_error: redirect_url.errorMessage,

//       publish_from_field: title,
//       publish_from: publish_from.value,
//       publish_from_error: publish_from.errorMessage,

//       publish_to_field: title,
//       publish_to: publish_to.value,
//       publish_to_error: publish_to.errorMessage,

//       age_from_field: title,
//       age_from: age_from.value,
//       age_from_error: age_from.errorMessage,

//       age_to_field: title,
//       age_to: age_to.value,
//       age_to_error: age_to.errorMessage,

const gender_male = ref<boolean>(false);
const gender_female = ref<boolean>(false);

const consumption_0 = ref<boolean>(false);
const consumption_30000 = ref<boolean>(false);
const consumption_50000 = ref<boolean>(false);
const consumption_100000 = ref<boolean>(false);

const prefecture_names = ref<string[]>(PREFECTURE_NAMES);

const show_detail_page = ref<boolean>(true);

//       body_field: title,
//       body: body.value,
//       body_error: body.errorMessage,
//     } as AdvertisementEditState;
//   },

const uploadFile = ref<HTMLInputElement>();

//   computed: {
const type = computed<string>(() => {
  return route.params.type.toString();
});

const type_name = computed<string>(() => {
  switch (type.value) {
    case "app":
      return "アプリホーム";
    case "systemtopic":
      return "PCブログランク";
    default:
      throw "No way";
  }
});

const salon_id = computed<string>(() => {
  return route.params.salon_id.toString();
});

//   },

//   mounted() {
//     refresh();
//   },

onMounted(() => {
  refresh();
});

//   methods: {
const refresh = () => {
  if (store.state.is_loading) {
    return;
  }

  const id = route.params.advertisement_id as string | null;

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      if (id) {
        advertisement.value = await Advertisement.get(id);

        console.log(advertisement.value);

        title.value = advertisement.value.title;
        redirect_url.value = advertisement.value.redirect_url;

        if (advertisement.value.publish_from) {
          const date = advertisement.value.publish_from as Date;
          publish_from.value = moment(date).format("YYYY-MM-DD");
        }

        if (advertisement.value.publish_to) {
          const date = advertisement.value.publish_to as Date;
          publish_to.value = moment(date).format("YYYY-MM-DD");
        }

        age_from.value = advertisement.value.target_age_from;
        age_to.value = advertisement.value.target_age_to;

        if (advertisement.value.target_genders) {
          gender_male.value =
            advertisement.value.target_genders.indexOf("male") >= 0;
          gender_female.value =
            advertisement.value.target_genders.indexOf("female") >= 0;
        }

        if (advertisement.value.target_consumptions) {
          consumption_0.value =
            advertisement.value.target_consumptions.indexOf("consumption_0") >= 0;
          consumption_30000.value =
            advertisement.value.target_consumptions.indexOf(
              "consumption_30000"
            ) >= 0;
          consumption_50000.value =
            advertisement.value.target_consumptions.indexOf(
              "consumption_50000"
            ) >= 0;
          consumption_100000.value =
            advertisement.value.target_consumptions.indexOf(
              "consumption_100000"
            ) >= 0;
        }

        if (advertisement.value.target_prefectures) {
          advertisement.value.target_prefectures.forEach((prefecture) => {
            const pi = prefecture_names.value.indexOf(prefecture);
            prefectures.value[pi] = true;
          });
        }

        show_detail_page.value = advertisement.value.show_detail_page;
        body.value = advertisement.value.body;
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

let mceCallback: ((uri: string, option: any) => void) | null = null;
const onFilePicked = (callback: (uri: string, option: any) => void) => {
  mceCallback = callback;
  uploadFile.value?.click();
};

const onUploadFileChanged = async () => {
  if (!uploadFile.value || !uploadFile.value?.files) {
    return;
  }
  try {
    const split = uploadFile.value?.files[0].name.split(".");
    const extension = split[split.length - 1];
    const filename = `${uuid.v4()}.${extension}`;
    Storage.configure({ customPrefix: { public: "advertisements" } });
    await Storage.put(`/${filename}`, uploadFile.value?.files[0], {
      contentType: extension == "png" ? "image/png" : "image/jpeg",
    });

    uploadFile.value!.value = "";

    if (mceCallback) {
      mceCallback(`${process.env.VUE_APP_HOST}/advertisements/${filename}`, {});
    }
  } catch (error) {
    console.log("Error uploading file: ", error);
  }
};

const onPrefectureChanged = (e: Event) => {
  console.log(`onPrefectureChanged: ${e.target}`);
  if (!(e.target instanceof HTMLInputElement)) {
    return;
  }

  const pindex = e.target.attributes.getNamedItem("data-pindex")?.nodeValue;

  if (!pindex) {
    return;
  }

  prefectures.value[parseInt(pindex)] = !prefectures.value[parseInt(pindex)];
  console.log(prefectures);
};

const validate = async (): Promise<boolean> => {
  body_error.value = "";
  await title_field.validate();
  await redirect_url_field.validate();
  await publish_from_field.validate();
  await publish_to_field.validate();
  await age_from_field.validate();
  await age_to_field.validate();
  await body_field.validate();

  if (show_detail_page.value && !body.value) {
    body_error.value = "詳細ページを表示する場合は、説明文を入力してください";
  }

  return (
    !title_error.value &&
    !redirect_url_error.value &&
    !publish_from_error.value &&
    !publish_to_error.value &&
    !age_from_error.value &&
    !age_to_error.value &&
    !body_error.value
  );
};

const onSave = () => {
  console.log(`onSave: ${type.value}`);
  if (store.state.is_loading) {
    return;
  }

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const valid = await validate();
      if (!valid) {
        return;
      }

      const target_genders: string[] = [];
      if (gender_male.value) {
        target_genders.push("male");
      }
      if (gender_female.value) {
        target_genders.push("female");
      }

      const target_consumptions: string[] = [];
      if (consumption_0.value) {
        target_consumptions.push("consumption_0");
      }
      if (consumption_30000.value) {
        target_consumptions.push("consumption_30000");
      }
      if (consumption_50000.value) {
        target_consumptions.push("consumption_50000");
      }
      if (consumption_100000.value) {
        target_consumptions.push("consumption_100000");
      }
      const target_prefectures: string[] = [];

      prefectures.value.forEach((flg, index) => {
        if (flg) {
          target_prefectures.push(PREFECTURE_NAMES[index]);
        }
      });

      if (!advertisement.value) {
        await Advertisement.register(
          type.value,
          title.value,
          redirect_url.value,
          body.value,
          publish_from.value ? moment(publish_from.value).toDate() : null,
          publish_to.value ? moment(publish_to.value).toDate() : null,
          age_from.value,
          age_to.value,
          target_genders.length ? target_genders : null,
          target_consumptions.length ? target_consumptions : null,
          target_prefectures.length ? target_prefectures : null,
          show_detail_page.value
        );
      } else {
        await Advertisement.update(
          advertisement.value.id,
          title.value,
          redirect_url.value,
          body.value,
          publish_from.value ? moment(publish_from.value).toDate() : null,
          publish_to.value ? moment(publish_to.value).toDate() : null,
          age_from.value,
          age_to.value,
          target_genders.length ? target_genders : null,
          target_consumptions.length ? target_consumptions : null,
          target_prefectures.length ? target_prefectures : null,
          show_detail_page.value
        );
      }

      if (type.value == "app") {
        router.push(`/advertisements/app`);
      } else if (type.value == "web") {
        router.push(`/advertisements/web`);
      }
    } finally {
      store.dispatch("setLoading", false);
    }
  });
  console.log(this);
};
// },
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, " 広告(" + _toDisplayString(_unref(type_name)) + ")追加 ", 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["px-3 py-2 max-w-full w-full focus:outline-none border-gray-200 rounded dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(title_error) }]),
            placeholder: "タイトル",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(title) ? (title).value = $event : null))
          }, null, 2), [
            [_vModelText, _unref(title)]
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(title_error)), 1)
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["px-3 py-2 max-w-full w-full focus:outline-none border-gray-200 rounded dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(redirect_url_error) }]),
            placeholder: "転送先URL",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(redirect_url) ? (redirect_url).value = $event : null))
          }, null, 2), [
            [_vModelText, _unref(redirect_url)]
          ]),
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(redirect_url_error)), 1)
        ])
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: _normalizeClass(["px-3 py-2 w-full focus:outline-none border-gray-200 rounded dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(publish_from_error) }]),
            placeholder: "表示期間(開始)",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(publish_from) ? (publish_from).value = $event : null))
          }, null, 2), [
            [_vModelText, _unref(publish_from)]
          ]),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(publish_from_error)), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: _normalizeClass(["px-3 py-2 w-full focus:outline-none border-gray-200 rounded dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(publish_to_error) }]),
            placeholder: "表示期間(終了)",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(publish_to) ? (publish_to).value = $event : null))
          }, null, 2), [
            [_vModelText, _unref(publish_to)]
          ]),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(publish_to_error)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: _normalizeClass(["px-3 py-2 w-full focus:outline-none border-gray-200 rounded dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(age_from_error) }]),
            placeholder: "対象年齢(開始)",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(age_from) ? (age_from).value = $event : null))
          }, null, 2), [
            [_vModelText, _unref(age_from)]
          ]),
          _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(age_from_error)), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: _normalizeClass(["px-3 py-2 w-full focus:outline-none border-gray-200 rounded dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(age_to_error) }]),
            placeholder: "対象年齢(終了)",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(age_to) ? (age_to).value = $event : null))
          }, null, 2), [
            [_vModelText, _unref(age_to)]
          ]),
          _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(age_to_error)), 1)
        ])
      ]),
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("label", _hoisted_27, [
            _withDirectives(_createElementVNode("input", {
              class: "cursor-pointer",
              type: "checkbox",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((gender_female).value = $event))
            }, null, 512), [
              [_vModelCheckbox, gender_female.value]
            ]),
            _createTextVNode(" 女性 ")
          ]),
          _createElementVNode("label", _hoisted_28, [
            _withDirectives(_createElementVNode("input", {
              class: "cursor-pointer",
              type: "checkbox",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((gender_male).value = $event))
            }, null, 512), [
              [_vModelCheckbox, gender_male.value]
            ]),
            _createTextVNode(" 男性 ")
          ])
        ])
      ]),
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("label", _hoisted_32, [
            _withDirectives(_createElementVNode("input", {
              class: "cursor-pointer",
              type: "checkbox",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((consumption_0).value = $event))
            }, null, 512), [
              [_vModelCheckbox, consumption_0.value]
            ]),
            _createTextVNode(" 0~30,000円 ")
          ]),
          _createElementVNode("label", _hoisted_33, [
            _withDirectives(_createElementVNode("input", {
              class: "cursor-pointer",
              type: "checkbox",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((consumption_30000).value = $event))
            }, null, 512), [
              [_vModelCheckbox, consumption_30000.value]
            ]),
            _createTextVNode(" 30,000~50,000円 ")
          ]),
          _createElementVNode("label", _hoisted_34, [
            _withDirectives(_createElementVNode("input", {
              class: "cursor-pointer",
              type: "checkbox",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((consumption_50000).value = $event))
            }, null, 512), [
              [_vModelCheckbox, consumption_50000.value]
            ]),
            _createTextVNode(" 50,000~100,000円 ")
          ]),
          _createElementVNode("label", _hoisted_35, [
            _withDirectives(_createElementVNode("input", {
              class: "cursor-pointer",
              type: "checkbox",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((consumption_100000).value = $event))
            }, null, 512), [
              [_vModelCheckbox, consumption_100000.value]
            ]),
            _createTextVNode(" 100,000円~ ")
          ])
        ])
      ]),
      _hoisted_36,
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prefectures.value, (prefecture, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: index,
              class: "nowrap"
            }, [
              _createElementVNode("label", _hoisted_39, [
                _withDirectives(_createElementVNode("input", {
                  class: "cursor-pointer",
                  type: "checkbox",
                  "data-pindex": index,
                  "onUpdate:modelValue": ($event: any) => ((prefectures.value[index]) = $event)
                }, null, 8, _hoisted_40), [
                  [_vModelCheckbox, prefectures.value[index]]
                ]),
                _createTextVNode(" " + _toDisplayString(prefecture_names.value[index]), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _withDirectives(_createElementVNode("input", {
            class: "mr-2 cursor-pointer",
            type: "checkbox",
            id: "form_show_detail_page",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((show_detail_page).value = $event))
          }, null, 512), [
            [_vModelCheckbox, show_detail_page.value]
          ]),
          _hoisted_44
        ])
      ]),
      _createVNode(_unref(Editor), {
        apiKey: "6q2dpclc7cej6s5lf27smv4shxp5gq17tspjczs8owhanety",
        init: {
          language: 'ja',
          height: 480,
          plugins: 'link image code',
          menubar: 'edit insert format forecolor table code',
          toolbar:
            'insertfile undo redo | styleselect | forecolor backcolor | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image pagebreak | code',
          file_picker_types: 'image media',
          file_picker_callback: onFilePicked,
        },
        modelValue: _unref(body),
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(body) ? (body).value = $event : null))
      }, null, 8, ["init", "modelValue"]),
      _createElementVNode("input", {
        type: "file",
        ref_key: "uploadFile",
        ref: uploadFile,
        accept: "image/jpeg,image/png",
        style: {"width":"0px"},
        onChange: onUploadFileChanged
      }, null, 544),
      _createElementVNode("span", _hoisted_45, _toDisplayString(body_error.value), 1)
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("button", {
        class: "shadow bg-yellow-700 hover:bg-yellow-500 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded",
        type: "button",
        onClick: _withModifiers(onSave, ["prevent"])
      }, " 登録 ", 8, _hoisted_47)
    ])
  ]))
}
}

})